module.exports = __webpack_public_path__ + "static/ProjectOverview-6bdf1fe6791e9344d1f9d692edc0796f.png";